(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[51084],{

/***/ 70227:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[authorID]/courses",
      function () {
        return __webpack_require__(97782);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 97782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(35944);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8100);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52420);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18446);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_isEqual__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _cont_EducatorProfile_EducatorCourses__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92750);
/* harmony import */ var _seo_index__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14432);
/* harmony import */ var _hooks_useInfiniteFetch__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(31843);
/* harmony import */ var _api_processors_course__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41327);
/* harmony import */ var _selectors_auth__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(34497);
/* harmony import */ var _layout_index__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(61988);
/* harmony import */ var _utils_escapeHTML__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(4297);
/* harmony import */ var _cont_App_PageReduxProviderWrapper__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(27300);


















var courseMiddleware = function(useSWRNext) {
    return function(key, fetcher, config) {
        var ref;
        var swr = useSWRNext(key, fetcher, config);
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, swr), {
            data: ((ref = swr.data) === null || ref === void 0 ? void 0 : ref.map(function(page) {
                var ref;
                if (page.processed) {
                    return page;
                }
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, page), {
                    processed: true,
                    results: ((ref = page.results) === null || ref === void 0 ? void 0 : ref.map(function(course) {
                        return (0,_api_processors_course__WEBPACK_IMPORTED_MODULE_8__/* .processCourse */ .A)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, course, course.programme || {}));
                    })) || []
                });
            })) || []
        });
    };
};
var useCoursesByFilters = function(param, param1) {
    var userName = param.userName, filtersApplied = param1.filtersApplied, sortsApplied = param1.sortsApplied, offset = param1.offset, options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
        fallbackData: undefined
    };
    var filterParams = {
        limit: 12,
        filters_applied: JSON.stringify(filtersApplied)
    };
    var key = "v1/search_v3/educators/".concat(userName, "/courses/v2/");
    if (sortsApplied) filterParams.sorts_applied = JSON.stringify(sortsApplied);
    if (offset) filterParams.offset = offset;
    var _ref = (0,_hooks_useInfiniteFetch__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(key, {
        applyOffsetsAutomatically: false,
        params: filterParams
    }, {
        use: [
            courseMiddleware
        ],
        fallbackData: options.fallbackData,
        revalidateOnMount: options.revalidateOnMount
    }), coursesByFilters = _ref.data, isValidating = _ref.isValidating, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(_ref, [
        "data",
        "isValidating"
    ]);
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
        key: key,
        isValidating: isValidating
    }, rest), {
        coursesByFilters: coursesByFilters
    });
};
var getFiltersApplied = function(query) {
    return {
        topic: {
            id: query.topic || ""
        },
        show_only: {
            id: query.courses || ""
        },
        goal: {
            id: query.goal || ""
        },
        language: {
            id: query.language || ""
        },
        filter_by: {
            id: query.type || "plus"
        }
    };
};
var Courses = function(param) {
    var profileInfo = param.profileInfo, fallbackCourses = param.fallbackCourses, filtersAppliedOnServer = param.filtersAppliedOnServer, authorID = param.authorID;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var cache = (0,swr__WEBPACK_IMPORTED_MODULE_0__/* .useSWRConfig */ .kY)().cache;
    var isLoggedIn = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_selectors_auth__WEBPACK_IMPORTED_MODULE_9__/* .getIsLoggedIn */ .M7);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(filtersAppliedOnServer), filtersApplied = ref[0], setFiltersApplied = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), sortsApplied = ref1[0], setSortsApplied = ref1[1];
    var ref2 = useCoursesByFilters({
        userName: authorID === null || authorID === void 0 ? void 0 : authorID.slice(1),
        type: ""
    }, {
        filtersApplied: getFiltersApplied(router.query),
        sortsApplied: sortsApplied
    }, {
        fallbackData: [
            fallbackCourses
        ],
        revalidateOnMount: false
    }), coursesByFilters = ref2.coursesByFilters, refetchData = ref2.mutate, isValidating = ref2.isValidating, setSize = ref2.setSize;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (isLoggedIn) {
            cache.clear();
            setSize(1);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isLoggedIn
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var currentFilter = getFiltersApplied(router.query);
        if (!lodash_isEqual__WEBPACK_IMPORTED_MODULE_4___default()(currentFilter, filtersApplied)) {
            setFiltersApplied(currentFilter);
            cache.clear();
            setSize(1);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        router.query
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(_cont_EducatorProfile_EducatorCourses__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        authorID: authorID,
        filtersApplied: filtersApplied,
        profileInfo: profileInfo,
        setSortsApplied: setSortsApplied,
        filteredCoursesData: {
            coursesByFilters: coursesByFilters,
            updateCoursesListData: refetchData,
            isValidating: isValidating,
            setSize: setSize
        }
    });
};
var CoursesPage = function(param) {
    var profileInfo = param.profileInfo, fallbackCourses = param.fallbackCourses, filtersAppliedOnServer = param.filtersAppliedOnServer;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var authorID = router.query.authorID;
    if (!authorID.startsWith("@")) authorID = "@".concat(authorID);
    authorID = (0,_utils_escapeHTML__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(authorID);
    var firstName = profileInfo.firstName, lastName = profileInfo.lastName, description = profileInfo.description;
    var title = "".concat(firstName, " ").concat(lastName, " courses | Unacademy");
    var url = "https://unacademy.com/".concat(authorID);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)(swr__WEBPACK_IMPORTED_MODULE_0__/* .SWRConfig */ .J$, {
        value: {
            revalidateOnMount: false,
            dedupingInterval: 60 * 1000
        },
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(_seo_index__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                title: title,
                url: url,
                description: description,
                openGraph: {
                    title: title,
                    description: description,
                    url: url
                }
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(Courses, {
                profileInfo: profileInfo,
                fallbackCourses: fallbackCourses,
                filtersAppliedOnServer: filtersAppliedOnServer,
                authorID: authorID
            })
        ]
    });
};
CoursesPage.pageInfo = {
    layoutOptions: {
        hideFooter: true
    },
    isMWebSupported: true
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (CoursesPage);
CoursesPage.propTypes = {
    profileInfo: prop_types__WEBPACK_IMPORTED_MODULE_17___default().objectOf((prop_types__WEBPACK_IMPORTED_MODULE_17___default().any)).isRequired,
    fallbackCourses: prop_types__WEBPACK_IMPORTED_MODULE_17___default().objectOf((prop_types__WEBPACK_IMPORTED_MODULE_17___default().any)).isRequired,
    filtersAppliedOnServer: prop_types__WEBPACK_IMPORTED_MODULE_17___default().objectOf((prop_types__WEBPACK_IMPORTED_MODULE_17___default().any)).isRequired
};
CoursesPage.Layout = _layout_index__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z;
CoursesPage.Wrapper = _cont_App_PageReduxProviderWrapper__WEBPACK_IMPORTED_MODULE_11__["default"];


/***/ }),

/***/ 4297:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var escape = function(string) {
    return (string || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;").replace(/\u200b/g, "").replace(/â€‹/g, "");
};
/* harmony default export */ __webpack_exports__["Z"] = (escape);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [35303,82492,52420,86924,96523,64412,25675,61608,41664,92781,21322,94133,80365,38516,32755,9720,94336,16050,56046,50648,70622,95965,48631,61988,48392,49917,90706,49774,92888,40179], function() { return __webpack_exec__(70227); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);